export const VIEW_BY_OPTION_VALUE = {
  ACCOUNT: "ACCOUNT",
  INVOICE: "INVOICE",
  REGION: "REGION",
  TAG: "TAG"
};

export const APPLY_TYPE = {
  RATIO:'R',
  STATIC:'S',
  INTERVAL:'I',
};

export const TREE_LAYER_SEPARATOR = "#!##!#!##!";

export const VIEW_BY_OPTIONS = [
  {
    text: 'billing.billingSummary.account',
    value: VIEW_BY_OPTION_VALUE.ACCOUNT
  },
  {
    text: 'billing.billingSummary.invoices',
    value: VIEW_BY_OPTION_VALUE.INVOICE
  },
  {
    text: 'billing.billingSummary.region',
    value: VIEW_BY_OPTION_VALUE.REGION
  },
  {
    text: 'billing.billingSummary.tag',
    value: VIEW_BY_OPTION_VALUE.TAG
  }
];

export const TAB_INDEX = {
  CHARGE_LIST: 0,
  CLOUD_INVOICE_LIST: 1,
  CLOUD_BILL_DETAIL: 2,
};

export const CHART_DOWNLOAD_OPTION_VALUE = {
  CSV: 'CSV'
};

export const CHART_DOWNLOAD_OPTIONS = [
  {
    text: 'billing.monthlyBillTrend.download.option.monthlyBillAmountForCurrentView(CSV)',
    value: CHART_DOWNLOAD_OPTION_VALUE.CSV
  },
];

export const DETAIL_TABLE_DOWNLOAD_OPTION_VALUE = {
  CHARGE_LIST_ON_CURRENT_VIEW: 'CHARGE_LIST_ON_CURRENT_VIEW',
  CLOUD_INVOICE_LIST_ON_CURRENT_VIEW: 'CLOUD_INVOICE_LIST_ON_CURRENT_VIEW',
  CLOUD_BILL_DETAILS: 'CLOUD_BILL_DETAILS'
};

export const DETAIL_TABLE_DOWNLOAD_OPTIONS = [
  {
    text: 'billing.chargeList.download.option.chargeListOnCurrentView(CSV)',
    value: DETAIL_TABLE_DOWNLOAD_OPTION_VALUE.CHARGE_LIST_ON_CURRENT_VIEW
  },
  {
    text: 'billing.invoiceList.download.option.cloudInvoiceListOnCurrentView(CSV)',
    value: DETAIL_TABLE_DOWNLOAD_OPTION_VALUE.CLOUD_INVOICE_LIST_ON_CURRENT_VIEW
  },
  {
    text: 'billing.cloudBillDetails.download.option.cloudBillDetails(CSV)',
    value: DETAIL_TABLE_DOWNLOAD_OPTION_VALUE.CLOUD_BILL_DETAILS
  }
];

// The request model use for get usages on coverage page
export const REQUEST_COVERAGE_FILTER_DATA_MODEL = {
  'companyId': 1,
  'siteCode': 'BESPIN',
  'userEmail': 'string',
  'userId': 'string',
  'userName': 'string',
  'vendor': 'string',
  'startDate' : '202001',
  'endDate' : '202007'
};

export const REQUEST_COVERAGE_USAGE_MODEL = {
  'companyId': 1,
  'siteCode': 'BESPIN',
  'userEmail': '',
  'userId': '',
  'userName': '',
  'vendor': '',
  'startDate' : '202001',
  'endDate' : '202007',
  'sortField' : '',
  'start' : '1',
  'limit' : '20',
};

// The request model use for get usages on coverage page
export const REQUEST_COVERAGE_TOTAL_SUMMARY_MODEL = {
  'companyId': 1,
  'siteCode': 'BESPIN',
  'userEmail': 'string',
  'userId': 'string',
  'userName': 'string',
  'vendor': 'string',
  'startDate' : '202001',
  'endDate' : '202007',
  'accounts' : null,
  'serviceTypes' : null,
  'regions' : null,
  'instanceFamilies' : null
};
export const REQUEST_COVERAGE_TRANSITION_MODEL = {
  'companyId': 1,
  'siteCode': 'BESPIN',
  'userEmail': 'string',
  'userId': 'string',
  'userName': 'string',
  'vendor': 'string',
  'startDate' : '202001',
  'endDate' : '202007',
  'accounts' : null,
  'serviceTypes' : null,
  'regions' : null,
  'instanceFamilies' : null
};
/**
 * When active month is 6, first month in monthly cost trend should be 6 - 5 = 1
 *
 * @type {number}
 */
export const DEFAULT_NUMBER_OF_PREVIOUS_MONTHS = 5;

/**
 * When active month is 6, last month in monthly cost trend should be 6 + 6 = 12
 *
 * @type {number}
 */
export const DEFAULT_NUMBER_OF_NEXT_MONTHS = 6;

/**
 * This fields with negative value (-)
 *
 * @type {Array}
 */
export const NEGATIVE_FIELDS = [
  'salesDiscount',
  'credit'
];

export const TREE_LAYER_SIZE = {
  LAYER_1_SIZE : "%layer1Size%",
  LAYER_2_SIZE : "%layer2Size%",
  LAYER_3_SIZE : "%layer3Size%",
  LAYER_4_SIZE : "%layer4Size%",
  LAYER_5_SIZE : "%layer5Size%",
};

export const VENDOR_NAMES = {
  AWS: 'AWS',
  AZURE: 'Azure',
  GCP: 'GCP'
};

export const NON_TAG_NAME = "NON-TAG";

export const BILLING_NEW_UPDATE = {
  BILL_SUMMARY: 'bill_summary',
  CHARGE_LIST: 'charge_list',
  CLOUD_INVOICE_LIST: 'cloud_invoice_list',
  CLOUD_BILL_DETAIL: 'cloud_bill_detail',
};

export const BILLING_NEW_UPDATE_OPTIONS = [
  {
    text: 'onboarding.welcome.newUpdates.billing.billSummary',
    value: BILLING_NEW_UPDATE.BILL_SUMMARY
  },
  {
    text: 'onboarding.welcome.newUpdates.billing.chargeList',
    value: BILLING_NEW_UPDATE.CHARGE_LIST
  },
  {
    text: 'onboarding.welcome.newUpdates.billing.invoiceList',
    value: BILLING_NEW_UPDATE.CLOUD_INVOICE_LIST
  },
  {
    text: 'onboarding.welcome.newUpdates.billing.cloudBillDetail',
    value: BILLING_NEW_UPDATE.CLOUD_BILL_DETAIL
  },
];

export const CHARGE_LIST_DETAILS_COST_VALUE = {
  CLOUD_ORIGINAL_COST: 'cloudOriginalCost',
  ON_DEMAND_DISCOUNT: 'onDemandDiscount',
  CF_DISCOUNT: 'cloudFrontDiscount',
  SUPPORT_FEE: 'supportFee',
  SALES_DISCOUNT: 'salesDiscount',
  CREDIT: 'credit',
};

export const CHARGE_LIST_DETAILS_COSTS = [
  {
    name: 'billing.billingChargeDetail.download.costNames.cloudOriginalCost',
    type: 'billing.billingChargeDetail.download.costTypes.cloud',
    value: CHARGE_LIST_DETAILS_COST_VALUE.CLOUD_ORIGINAL_COST
  },
  {
    name: 'billing.billingChargeDetail.download.costNames.onDemandDiscount',
    type: 'billing.billingChargeDetail.download.costTypes.cloud',
    value: CHARGE_LIST_DETAILS_COST_VALUE.ON_DEMAND_DISCOUNT
  },
  {
    name: 'billing.billingChargeDetail.download.costNames.cfDiscount',
    type: 'billing.billingChargeDetail.download.costTypes.cloud',
    value: CHARGE_LIST_DETAILS_COST_VALUE.CF_DISCOUNT
  },
  {
    name: 'billing.billingChargeDetail.download.costNames.supportFee',
    type: 'billing.billingChargeDetail.download.costTypes.cloud',
    value: CHARGE_LIST_DETAILS_COST_VALUE.SUPPORT_FEE
  },
  {
    name: 'billing.billingChargeDetail.download.costNames.salesDiscount',
    type: 'billing.billingChargeDetail.download.costTypes.cloud',
    value: CHARGE_LIST_DETAILS_COST_VALUE.SALES_DISCOUNT
  },
  {
    name: 'billing.billingChargeDetail.download.costNames.credit',
    type: 'billing.billingChargeDetail.download.costTypes.cloud',
    value: CHARGE_LIST_DETAILS_COST_VALUE.CREDIT
  },
];

export const USAGE_TYPE = {
  ADDEND_VALUE: 'addendValue',
  TOTAL_VALUE: 'totalValue'
}



// WEBPACK FOOTER //
// ./src/constants/savings-plans/coverageConstants.js